import { render, staticRenderFns } from "./InvestorProfileNote.vue?vue&type=template&id=a9cfc23c&scoped=true"
import script from "./InvestorProfileNote.vue?vue&type=script&lang=js"
export * from "./InvestorProfileNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9cfc23c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9cfc23c')) {
      api.createRecord('a9cfc23c', component.options)
    } else {
      api.reload('a9cfc23c', component.options)
    }
    module.hot.accept("./InvestorProfileNote.vue?vue&type=template&id=a9cfc23c&scoped=true", function () {
      api.rerender('a9cfc23c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/clientForms/exhibit-b-investor-profile/InvestorProfileNote.vue"
export default component.exports